import axios, { AxiosResponse } from "axios";
import { ApiResult, AxiosErr } from "../Contracts/IMdels";
import { BaseModel } from "./BaseModel";

export class TarefeModel extends BaseModel {
    RouteName = "Tariff";
    protected AuthState: boolean = true;

    public async GetSearch(title:any,
    vehicleTypeId:any,
    serviceTypeId:any,
    year:any,
    amountType:any,
    fixedAmount:any,
    percentValue:any,
    perDayAmount:any,
    perHourAmount:any,) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}/search?title=${title}&vehicleTypeId=${vehicleTypeId}&serviceTypeId=${serviceTypeId}&year=${year}&amountType=${amountType}&fixedAmount=${fixedAmount}&percentValue=${percentValue}&perDayAmount=${perDayAmount}&perHourAmount=${perHourAmount}`
            );
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }

            throw error.response?.data.message;
        }
    }
    public async GetAll() {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}`);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }

            throw error.response?.data.message;
        }
    }
    public async GetById(id:number|string) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).get(`${this.RouteName}/${id}`);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }

            throw error.response?.data.message;
        }
    }
    public async SubmitData(data: any) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).post(`${this.RouteName}`, data);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }
            throw error.response?.data.message;
        }
    }
    public async EditData(data: any) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).put(`${this.RouteName}`, data);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }
            throw error.response?.data.message;
        }
    }
    public async Delete(data: any) {
        try {
            return await this.baseApi.axiosInstance(this.AuthState).delete(`${this.RouteName}`, data);
        } catch (e: any) {
            const error = e as AxiosErr;
            if (axios.isCancel(error)) {
                throw error.message;
            }
            throw error.response?.data.message;
        }
    }

}
